export const formatFileSize = (bytes: number, decimalPoint?: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1000;
  const dm = decimalPoint || 2;
  const sizes = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const val = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / k ** val).toFixed(dm))} ${sizes[val]}`;
};
